import React from 'react';
export const BackgroundGradients = () => {
  return <>
      {/* Fixed position background elements that sit behind content */}
      <div className="fixed inset-0 z-[-2] overflow-hidden pointer-events-none" data-id="element-54">
        {/* Top gradient blob - soft green */}
        <div className="absolute top-[5%] left-[15%] w-[70vw] h-[45vh] rounded-full opacity-[0.07] blur-[120px]" style={{
        background: 'radial-gradient(circle, rgba(0,136,96,0.4) 0%, rgba(255,255,255,0) 70%)'
      }} data-id="element-55"></div>
        {/* Middle gradient blob - soft blue */}
        <div className="absolute top-[35%] right-[10%] w-[60vw] h-[40vh] rounded-full opacity-[0.06] blur-[100px]" style={{
        background: 'radial-gradient(circle, rgba(0,87,184,0.3) 0%, rgba(255,255,255,0) 70%)'
      }} data-id="element-56"></div>
        {/* Lower gradient blob - soft orange */}
        <div className="absolute top-[65%] left-[20%] w-[65vw] h-[45vh] rounded-full opacity-[0.05] blur-[130px]" style={{
        background: 'radial-gradient(circle, rgba(254,80,0,0.3) 0%, rgba(255,255,255,0) 70%)'
      }} data-id="element-57"></div>
        {/* Bottom gradient blob - soft violet */}
        <div className="absolute top-[95%] right-[15%] w-[70vw] h-[50vh] rounded-full opacity-[0.04] blur-[120px]" style={{
        background: 'radial-gradient(circle, rgba(165,24,144,0.25) 0%, rgba(255,255,255,0) 70%)'
      }} data-id="element-58"></div>
      </div>
      {/* Subtle diagonal lines pattern overlay */}
      <div className="fixed inset-0 z-[-1] opacity-[0.02] pointer-events-none" data-id="element-59">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-60">
          <defs data-id="element-61">
            <pattern id="diagonalLines" width="40" height="40" patternUnits="userSpaceOnUse" patternTransform="rotate(45)" data-id="element-62">
              <line x1="0" y1="0" x2="0" y2="40" stroke="#008860" strokeWidth="1" data-id="element-63" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#diagonalLines)" data-id="element-64" />
        </svg>
      </div>
    </>;
};